import * as THREE from 'three';
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, scene, camera, renderer, incRenderCount, createFloor } from './initThree';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Box from 'vux/src/components/box/index.vue'

import loading from '@/components/loading';
import { ModelMaker } from './ModelMaker';
import { PaintDrawer } from './PaintDrawerMobile';


import relief1 from '../imgs/装饰1.svg';
import relief2 from '../imgs/装饰2.svg';
import relief3 from '../imgs/装饰3.svg';
import relief4 from '../imgs/装饰4.svg';
import relief5 from '../imgs/装饰5.svg';
import relief6 from '../imgs/装饰6.svg';
import relief7 from '../imgs/装饰7.svg';
import relief8 from '../imgs/装饰8.svg';
import relief9 from '../imgs/装饰9.svg';
import relief10 from '../imgs/装饰10.svg';
import relief11 from '../imgs/装饰11.svg';
import relief12 from '../imgs/装饰12.svg';
import relief13 from '../imgs/装饰13.svg';
import relief14 from '../imgs/装饰14.svg';
import relief15 from '../imgs/装饰15.svg';
import relief16 from '../imgs/装饰16.svg';
import relief17 from '../imgs/装饰17.svg';
import relief18 from '../imgs/装饰18.svg';
import relief19 from '../imgs/装饰19.svg';
import relief20 from '../imgs/装饰20.svg';

let maker = new ModelMaker();
let drawer;


export default {
name: "jewelryPendant",
mixins: [printModel],
components: {
XDialog,
range: Range, radio: Radio, Group, Cell, loading, Checker, CheckerItem, XSwitch, XProgress, Box
},
data() {
return {
quotationName: "定制首饰挂件",
productType: "定制首饰挂件",
landscape: true,//竖屏状态要一直为true
showLoading: false,
showPrint: false,
showPrintImg: true,
showdownloadImg: true,
showDownloads: false,
showTabList: false,
addCartIndex: -1,
orderIndex: -1,
cur: 0, //默认选中第一个tab
btnsListIndex1: -1,
btnsListIndex2: -1,
isReliefIndex: 0,
disabled: false,
showMenu: true,
showdisplay: true,
showdisplayImg: true,
show2dPop: false,
showStrokesImg: true,
showEraserImg: true,
showStrokesPop: false,
draw: {
lineWidth: 5,//笔画粗细
},
btnsList1: [
{
isClick: false,
icon: require("../imgs/设置.png"),
iconClick: require("../imgs/设置（选中）.png"),
},
],
btnsList2: [
{
isClick: false,
icon: require("../imgs/撤回.png"),
iconClick: require("../imgs/撤回（选中）.png"),
},
{
isClick: false,
icon: require("../imgs/清空.png"),
iconClick: require("../imgs/清空（选中）.png"),
},
],
tabTitle: [
{
title: '预设',
enabled: true,
},
],
presupposList: [
{
src: relief1,
},
{
src: relief2,
},
{
src: relief3,
},
{
src: relief4,
},
{
src: relief5,
},
{
src: relief6,
},
{
src: relief7,
},
{
src: relief8,
},
{
src: relief9,
},
{
src: relief10,
},
{
src: relief11,
},
{
src: relief12,
},
{
src: relief13,
},
{
src: relief14,
},
{
src: relief15,
},
{
src: relief16,
},
{
src: relief17,
},
{
src: relief18,
},
{
src: relief19,
},
{
src: relief20,
},
],
}
},
mounted() {
const scope = this;
scope.showLoading = true;
scope.isclickDisplay();

var mo = function (e) {
e.preventDefault();
}

initThree(scope.$refs.canvas3d);
scope.floor = createFloor();


const contentDOM = scope.$refs.jewelryPendant;


const resize1 = function (e) {
if (!scope.$refs.canvas3d) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas3d.width = w; 
scope.$refs.canvas3d.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

const resize2 = function (e) {
if (!scope.$refs.canvas2d) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;


scope.$refs.canvas2d.width = w; 
scope.$refs.canvas2d.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);
scope.init3d(contentDOM, camera, renderer, resize2);



scope.$nextTick(function () {
scope.$refs.jewelryPendant.style.paddingTop = '0px';
scope.$refs.jewelryPendant.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});



var decorativePainting = this.$refs.tabList; 


var screenHeight = window.innerHeight;
window.onresize = function () {
if (screenHeight !== window.innerHeight) {

decorativePainting.style.bottom = 0 + "px";
decorativePainting.style.position = "absolute";
} else {

decorativePainting.style.bottom = 50 + "px";
decorativePainting.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


decorativePainting.onfocus = function () {
interval = setInterval(function () {
decorativePainting.style.bottom = 0 + "px";
decorativePainting.style.position = "absolute";
}, 500)
};


decorativePainting.onblur = function () {
decorativePainting.style.bottom = 50 + "px";
decorativePainting.style.position = "fixed";
clearInterval(interval);
};

incRenderCount();
maker.init(scene);

let canvas2d = document.getElementById("canvas2d");
drawer = new PaintDrawer(canvas2d);
drawer.onChange = function () {
maker.makeModel(drawer.currPathList);
incRenderCount();
};

scope.$nextTick(function () {
scope.loadData();
});
},
methods: {
updateMesh() {
if (this.noUpdateMesh) return;
this.showLoading = true;
incRenderCount();
},

selereliefItem(index) {
this.showLoading = true;
this.isReliefIndex = index;
setTimeout(() => {
console.log("selereliefItem", this.isReliefIndex);
}, 50);
},

isclickDisplay() {
this.showStrokesImg = true;
this.showEraserImg = true;
this.btnsList1[0].isClick = false;
this.btnsList2[0].isClick = false;
this.btnsList2[1].isClick = false;
this.showdisplayImg = !this.showdisplayImg;
this.show2dPop = !this.show2dPop;
this.$nextTick(function () {
drawer.updateSize();
});
},


isclickStrokes() {
this.showStrokesImg = !this.showStrokesImg;
this.showStrokesPop = !this.showStrokesPop;
},


isclickEraser() {
this.isTopBtn();
this.showEraserImg = !this.showEraserImg;
if (drawer.penType) {
drawer.penType = !"add";
} else {
drawer.penType = "add";
}
},

touchend1() {
this.showLoading = true;
this.noUpdateMesh = false;
incRenderCount();
this.showLoading = false;
drawer.lineWidth = this.draw.lineWidth;
this.isTopBtn();
},


loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("jewelryPendant");
localStorage.removeItem("jewelryPendant"); 
if (dataStr) {
scope.showLoading = true;
scope.noUpdateMesh = false;

let data = JSON.parse(dataStr);
scope.isReliefIndex = data.isReliefIndex;
scope.draw.lineWidth = data.lineWidth;
drawer.setData(data.drawerData);
} else {
console.log("err");
}

drawer.draw();





setTimeout(() => {
scope.showLoading = false;
}, 50);
}
},


saveData() {
const scope = this;

if (window.localStorage) {
let data = {};
data.isReliefIndex = scope.isReliefIndex;
data.lineWidth = scope.draw.lineWidth;
data.drawerData = drawer.getData();
localStorage.setItem("jewelryPendant", JSON.stringify(data));
}
},

handler1(index) {

this.btnsListIndex1 = index;
this.showSetImg = !this.showSetImg;
this.showTabList = !this.showTabList;
this.btnsList1[0].isClick = true;
this.showdisplay = !this.showdisplay;
this.showdisplayImg = !this.showdisplayImg;
this.resize();
if (!this.showTabList) {
this.optimizedBtnClick();
this.resize();
return;
}
return;
},

handler2(index) {
this.btnsListIndex2 = index;
this.showStrokesImg = true;
this.showEraserImg = true;
this.showdisplay = true;
this.showdisplayImg = true;
if (this.btnsListIndex2 === 0) {//撤回
this.optimizedBtnClick();
this.btnsList2[0].isClick = true;
this.$nextTick(function () {
drawer.goBack();
});
} else if (this.btnsListIndex2 === 1) {//清空
this.optimizedBtnClick();
this.btnsList2[1].isClick = true;
this.$nextTick(function () {
drawer.clearAll();
});
}
return;
},


downloadsBtn() {
this.showDownloads = !this.showDownloads;
this.showdownloadImg = !this.showdownloadImg;
},


downloads() {
const scope = this;
scope.showDownloads = false;
scope.showLoading = true;

if (maker.group) {

if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "penholder",
}).then(function (res) {
console.log("res", res);
if (res.obj === null) {
scope.$vux.toast.show({
text: '模型不能为空',
type: "warn",
time: 2000,
position: "middle",
});
scope.showLoading = false;
scope.showDownloads = false;
return;
} else {
scope.downloadModels();
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.isTopBtn();
scope.showLoading = false;
}, 50);
}
});
}
} else {
scope.$vux.toast.show({
text: '模型不能为空',
type: "warn",
time: 2000,
position: "middle",
});
scope.showLoading = false;
scope.showDownloads = false;
return;
}
},

downloadModels() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(maker.group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
let filename = "定制首饰挂件.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

optimizedBtnClick() {
this.btnsList1[0].isClick = false;
this.btnsList2[0].isClick = false;
this.btnsList2[1].isClick = false;
this.btnsListIndex1 = -1;
this.btnsListIndex2 = -1;
},


touchstart() {
this.isTopBtn();
this.resize();
},

isTopBtn() {
this.showPrint = false;
this.showTabList = false;
this.showDownloads = false;
this.showdownloadImg = true;
this.showPrintImg = true;
this.showdisplay = true;
this.showdisplayImg = true;
this.showStrokesImg = true;
this.showEraserImg = true;
this.showStrokesPop = false;
this.optimizedBtnClick();
this.resize();
},


resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.btnsListIndex1 == 0 || this.btnsListIndex1 == 1) {
let tabHeight = h * 0.2;
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
incRenderCount();
},

getModelToPrint() {
return maker.group;
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = maker.group;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},

closePrint() {
this.isTopBtn();
},

getUploadUrl() {
return "/SmallSoftware/uploadFile";
},


print() {
this.modelSplit = true;
this.isTopBtn();
this.showLoading = true;
this.showPrintImg = !this.showPrintImg;

if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
}

setTimeout(() => {
if (maker.group) {
this.saveData();
this.noUpdateMesh = false;
this.updateMesh();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});
} else {
this.$vux.toast.show({
text: '定制装饰画不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.noUpdateMesh = false;
this.updateMesh();
}
incRenderCount();
this.showLoading = false;
}, 50);
},
},
}



// WEBPACK FOOTER //
// ./src/views/jewelryPendant/scripts/jewelryPendant.js